import { ScrollView, Text, View } from 'react-native'
import { useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { CANCEL_BUY_ORDER } from '@/constants/graphql/mutations'
import type { BuyQueryResult } from '@/types/common'
import { delay } from '@/utils/delay'
import { Button, useModal, useToast } from '@/components/base'
import BottomActionPanel from '@/components/BottomActionPanel'
import { useLoadingIndicator } from '@/components/LoadingIndicator'
import CancelModal from '@/components/orders/CancelModal'
import { ChildOrderDetailSection } from '@/components/orders/child/DetailSection'

export function BuyerMatchingScreen({
  data,
  refetch
}: {
  data: BuyQueryResult['userGetBuyOrderByInternalKey']
  refetch: () => void
}) {
  const { t } = useTranslation()
  const toast = useToast()
  const loading = useLoadingIndicator()
  const { bottom } = useSafeAreaInsets()
  const { openModal, closeModal } = useModal()
  const [cancelBuyOrder] = useMutation(CANCEL_BUY_ORDER, {
    onCompleted: async (data: any) => {
      // console.log('completed', data)
      await delay(500)
      loading.stop()
      refetch()
    },
    onError: (error) => {
      console.error('cancelBuyOrder error:', error)
      refetch()
      loading.stop()
      toast.show({ variant: 'error', description: t('auth:toast.error.invalidOperationHint') })
    }
  })

  function handleCancelBuyOrder() {
    cancelBuyOrder({
      variables: {
        buyOrderId: data.id
      }
    })
  }

  return (
    <View className={'flex-1 bg-background-secondary'}>
      <ScrollView className={'flex-1'} contentContainerStyle={{ paddingBottom: bottom + 72 }}>
        <View className={'border-b border-border-10 bg-background-primary px-4 pb-[11px] pt-2'}>
          <Text className={'text-2xl font-semibold text-text-primary'}>{t('orders:listing')}</Text>
        </View>
        <ChildOrderDetailSection data={data} type={'buy'} />
      </ScrollView>
      <BottomActionPanel>
        <Button
          size={'md'}
          intent={'primary'}
          variant={'outline'}
          className={'flex-1'}
          disabled={loading.isLoading}
          onPress={() => {
            openModal({
              children: (
                <CancelModal
                  onSubmit={() => {
                    handleCancelBuyOrder()
                    loading.start()
                  }}
                />
              ),
              onClose: closeModal
            })
          }}
        >
          {t('orders:unlistOrder')}
        </Button>
      </BottomActionPanel>
    </View>
  )
}
